// extracted by mini-css-extract-plugin
export var container = "town-selection-view-module--container--2Ixu8";
export var prefectureCityText = "town-selection-view-module--prefectureCityText--3Pxm9";
export var townRow = "town-selection-view-module--townRow--1cAYD";
export var townLinkText = "town-selection-view-module--townLinkText--1xiDE";